import { render, staticRenderFns } from "./GenericProductAttributesExcelModal.vue?vue&type=template&id=c1387b3c&scoped=true&"
import script from "./GenericProductAttributesExcelModal.vue?vue&type=script&lang=js&"
export * from "./GenericProductAttributesExcelModal.vue?vue&type=script&lang=js&"
import style0 from "./GenericProductAttributesExcelModal.vue?vue&type=style&index=0&id=c1387b3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1387b3c",
  null
  
)

export default component.exports